import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';

export interface Triangle {
    triangleInfo: {
        [activityId: string]: Triangle.TriangleInfo;
    };
    triangleDetail: {
        [activityId: string]: Triangle.TriangleDetail;
    };
    triangleGroupDetail: {
        [groupId: string]: Triangle.TriangleDetail;
    };
}

const m: Module<Triangle, RootState> = {
    namespaced: true,
    state: {
        triangleInfo: {},
        triangleDetail: {},
        triangleGroupDetail: {},
    },
    mutations: {
        setTriangleInfo(state, { activityId, data }) {
            Vue.set(state.triangleInfo, activityId, data);
        },
        setTriangleDetail(state, { activityId, data }) {
            Vue.set(state.triangleDetail, activityId, data);
        },
        setTriangleGroupDetail(state, { groupId, data }) {
            Vue.set(state.triangleGroupDetail, groupId, data);
        },
    },
    actions: {
        /**
         * 获取活动信息
         */
        async getTriangleInfo(context, { activityId }) {
            const response = await Vue.axios.get('/api/v1/triangle/info', {
                params: {
                    activity_id: activityId,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                context.commit('setTriangleInfo', {
                    activityId,
                    data: rdata.data,
                });
            }
            return rdata;
        },
        /**
         * 获取详情
         */
        async getTriangleDetail(context, { activityId }) {
            const response = await Vue.axios.get('/api/v1/triangle/detail', {
                params: {
                    activity_id: activityId,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                context.commit('setTriangleDetail', {
                    activityId,
                    data: rdata.data,
                });
            }
            return rdata.data;
        },
        /**
         * 获取队伍详情
         */
        async getTriangleGroupDetail(context, { groupId }) {
            const response = await Vue.axios.get('/api/v1/triangle/group_detail', {
                params: {
                    group_id: groupId,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                context.commit('setTriangleGroupDetail', {
                    groupId,
                    data: rdata.data,
                });
            }
            return rdata.data;
        },
        /**
         * 发起活动
         */
        async postTriangle(context, {activityId} ) {
            const response = await Vue.axios.post('/api/v1/triangle', {
                activity_id: activityId,
            });
            const rdata = response.data;
            return rdata;
        },
        /**
         * 关闭活动
         */
        async triangleCancel(context, {activityId} ) {
            const response = await Vue.axios.post('/api/v1/triangle/cancel', {
                activity_id: activityId,
            });
            const rdata = response.data;
            return rdata;
        },
    },
};

export default m;
